import { ProductCardVertical } from './products/ProductCardVertical';
import { AuthShell } from './shell/AuthShell';
import { useContext, useState } from 'react';
import { PageContext } from '../contexts/pageContext';
import { v4 as uuidv4 } from 'uuid';
import { useDisclosure } from '@mantine/hooks';
import { ShareButton } from './ShareButton';
import { useEffect } from 'react';
import {merchantMonetizeAndSwap} from "./utils/Monetize"
import {updateProductLinkFallback} from './utils/Affiliates';
import posthog from 'posthog-js';

export function ProductCollection(props: any) {
    const context = useContext(PageContext);
    const [showAuthPrompt, setShowAuthPrompt] = useState(false);
    const [feedbackOpened, setFeedbackOpened] = useState(false);
    const [loggedinusername, setLoggedInUsername] = useState("");
    const [uid, setUser] = useState(null);
    const [profile, setProfile] = useState(null);
    const sessionUUID = props.threadId || uuidv4();
    const [openedCheckout, { toggle }] = useDisclosure(false);
    const [checkoutProduct, setCheckoutProduct] = useState(null);
    const [products, setProducts] = useState(props.products || null);
    const AFFILIATE_LINK = context.affiliateLink;

    useEffect(() => {
        // Track page view with posthog

        const shouldUpdateLinks = Math.random() < 1;

        const updateLinks = async (productsToUpdate) => {
          const updatedProducts = await Promise.all(productsToUpdate.map(async (product, index) => {
            return await merchantMonetizeAndSwap(product, AFFILIATE_LINK);
          }));
          return updatedProducts;
        };

        if (products && shouldUpdateLinks) {
          updateLinks(products).then(updatedProducts => {
            setProducts(updatedProducts);
          });
        }

        posthog.capture('product collection', {
            topic: props.topic,
            sessionId: sessionUUID,
            username: loggedinusername,
            numProducts: products?.length,
            currentUrl: window.location.href
        });

      }, [products]);

    return (
        <AuthShell
            loggedInUsername={loggedinusername}
            userid={uid}
            sessionUUID={sessionUUID}
            showAuthPrompt={showAuthPrompt}
            setShowAuthPrompt={setShowAuthPrompt}
            topicSelected={true}
            feedbackOpened={feedbackOpened}
            setFeedbackOpened={setFeedbackOpened}
            profile={profile}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {props.topic && (
                    <>
                    <div className='flex items-center justify-between  mt-4'>
                        <div className="flex justify-between py-4 text-lg md:text-xl lg:text-xl max-w-full">
                            <div className="items-center flex  pb-1 text-textMain line-clamp-1">
                            {props.topic}
                            </div>
                        </div>
                        <ShareButton sessionId={sessionUUID} isMobile={props.isMobile}/>
                    </div>
                    </>
                )}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {products && products.map((product, index) => (
                        <ProductCardVertical
                            key={product.id}
                            product={product}
                            image={product.imageUrl}
                            price={product.price}
                            title={product.title}
                            link={product.taggedURL}
                            detailPageURL={product.detailPageURL}
                            rating={product.rating}
                            sku={product.sku}
                            inlineProduct={true}
                            bestSeller={product.best_seller}
                            amazonsChoice={product.is_amazons_choice}
                            reviews_count={product.reviews_count}
                            source={product.source}
                            references={product.references}
                            index={index}
                            aiSummary={product.aiSummary}
                            setCheckoutProduct={setCheckoutProduct}
                            className='px-2'
                            openedCheckout={openedCheckout}
                            toggleCheckout={toggle}
                        />
                    ))}
                </div>
            </div>
        </AuthShell>
    );
}